import { Layout } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useLogs } from '../fetchHooks/useLogs';

const ShowLogs = () => {
  const { data: logs, isLoading, isError } = useLogs();

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  if (isError) {
    return <h1>Something went wrong</h1>;
  }

  return (
    <div className="app-container">
      <Layout className="layout-default">
        <Content className="layout-default" style={{ margin: '24px 16px 0' }}>
          <h2>Logs:</h2>
          <ul>
            {logs
              .split('\n')
              .reverse()
              .map((item: string, index: number) => (
                <p key={index}>
                  {index}: {item}
                </p>
              ))}
          </ul>
        </Content>
      </Layout>
    </div>
  );
};

export default ShowLogs;
